module.exports = __webpack_public_path__ + "img/service_icon_en.7a80537c.png";